<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<cms-empty-layout *ngIf="layout === 'empty'"></cms-empty-layout>
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Classic layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<cms-classic-layout *ngIf="layout === 'classic'"></cms-classic-layout>
